import {createAction} from "redux-act";
import {IProfile, IUser} from "modules/reducers";
import {IFormError} from "modules/types";

export const requestUser = createAction();
export const requestUserSuccess = createAction<IUser>();
export const requestUserFailed = createAction();

export const requestProfile = createAction();
export const requestProfileSuccess = createAction<IProfile>();
export const requestProfileFailed = createAction();

export interface ISaveProfilePayload {
	terms?: boolean | null;
	isNotificationsEnabled?: boolean | null;
	optInGZ?: boolean;
	hasSeenChampionLeagueAddingModal?: boolean;
	hasSeenChampionLeagueNextRoundModal?: boolean;
	hasSeenChampionLeagueRemovingModal?: boolean;
	hasSeenChampionLeagueWinnerModal?: boolean;
}

export const saveProfile = createAction<ISaveProfilePayload>();
export const saveProfileSuccess = createAction<IProfile>();
export const saveProfileFailed = createAction<IFormError>();

export const setFormError = createAction<IFormError>();
export const clearFormError = createAction<string | void>();

export const clearUserState = createAction();
